'use client';
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const DATA = [
  { year: '2021', master: 58, phd: 24 },
  { year: '2022', master: 72, phd: 31 },
  { year: '2023', master: 89, phd: 43 },
  { year: '2024', master: 124, phd: 67 },
  { year: '2025', master: 137, phd: 82 },
  { year: '2026', master: 55, phd: 65 },
];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: { name: string; value: number; color: string }[]; label?: string }) => {
  if (!active || !payload) return null;
  return (
    <div className="bg-white border border-[#e2e6f0] rounded-xl shadow-lg p-3 text-xs">
      <p className="font-700 text-[#0f1a35] mb-2">{label}</p>
      {payload.map((p) => (
        <div key={`tt-type-${p.name}`} className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
            <span className="text-[#4a5578]">{p.name === 'master' ? "Master's" : 'PhD'}</span>
          </div>
          <span className="font-700 text-[#0f1a35] tabular-nums">{p.value}</span>
        </div>
      ))}
      <div className="mt-1.5 pt-1.5 border-t border-[#f0f2f8] flex justify-between">
        <span className="text-[#8892a8]">Total</span>
        <span className="font-700 text-[#0f1a35] tabular-nums">{(payload[0]?.value || 0) + (payload[1]?.value || 0)}</span>
      </div>
    </div>
  );
};

export default function ThesisTypeDistributionChart() {
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={DATA} margin={{ top: 5, right: 10, left: -15, bottom: 5 }} barSize={20} barGap={4}>
        <CartesianGrid stroke="#e2e6f0" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="year" tick={{ fontSize: 11, fill: '#8892a8' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11, fill: '#8892a8' }} axisLine={false} tickLine={false} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="master" fill="#1a2e5a" radius={[3, 3, 0, 0]} name="master" />
        <Bar dataKey="phd" fill="#c9a84c" radius={[3, 3, 0, 0]} name="phd" />
      </BarChart>
    </ResponsiveContainer>
  );
}